module.exports = __webpack_public_path__ + "static/media/slidingDoor270.4f434ec1.png";